// @ts-nocheck
// TODO: tighten types after migration
import React, { useEffect } from "react";
import Header from "./Header";
import Home from "./Home/Home"
import Footer from "./footer";
// eslint-disable-next-line no-unused-vars
import Contact from "./Contact"
import { generateWebsiteStructuredData, generateOrganizationStructuredData } from "./utils/structuredData"
import "./utils/mobileSpeedAudit"
import "./utils/performanceMonitor"
import "./utils/securityArchitectureAudit"
import API_BASE_URL from "./config/api"
import useFavicon from "./utils/useFavicon"




export default function App(){
    useFavicon("/images/home_images/Logo_Transparent.png");

    // Warmup ping: wake Render.com backend on app load so it's ready when users navigate
    useEffect(() => {
        const isProduction = !window.location.hostname.includes('localhost');
        if (isProduction) {
            fetch(`${API_BASE_URL}/blog/categories`, { method: 'GET' })
                .catch(() => { /* best-effort warmup, ignore errors */ });
        }
    }, []);

    useEffect(() => {
        // Add website and organization structured data
        const websiteData = generateWebsiteStructuredData();
        const organizationData = generateOrganizationStructuredData();
        
        const websiteScript = document.createElement('script');
        websiteScript.type = 'application/ld+json';
        websiteScript.textContent = JSON.stringify(websiteData);
        websiteScript.id = 'website-structured-data';
        
        const organizationScript = document.createElement('script');
        organizationScript.type = 'application/ld+json';
        organizationScript.textContent = JSON.stringify(organizationData);
        organizationScript.id = 'organization-structured-data';
        
        document.head.appendChild(websiteScript);
        document.head.appendChild(organizationScript);
        
        return () => {
            const existingWebsite = document.getElementById('website-structured-data');
            const existingOrganization = document.getElementById('organization-structured-data');
            if (existingWebsite) document.head.removeChild(existingWebsite);
            if (existingOrganization) document.head.removeChild(existingOrganization);
        };
    }, []);

    return(
        <>
            <Header />
            <Home />
            <Footer />
        </>
    )
}